module.exports = __webpack_public_path__ + "img/notebook-pana.32380f58.svg";